/* eslint-disable no-useless-concat */
export const insertLiveTexScript = (id) => {
  window["l" + "i" + "v" + "eTe" + "x"] = true;
  window["li" + "ve" + "Te" + "x" + "ID"] = id;
  window["li" + "ve" + "Tex_" + "obj" + "ect"] = true;
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  script.src = "//cs15.livetex.ru/js/client.js";
  const c = document.getElementsByTagName("script")[0];
  if (c) {
    c.parentNode.insertBefore(script, c);
  } else {
    document.documentElement.firstChild.appendChild(script);
  }
};
